export const noNormalizer = (value: string) => value;
export const numericNormalizer = (value: string) => value.replace(/\D/g, "");
export const dateNormalizer = (value: string) =>
  new Date(value.replace(/-/g, "/")).toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
